export const getRandomBgColor = () => {
    const colorList = ['#404040', '#003F5E', '#FFC000', '#F2B600', '#003050'];
    let random_color = colorList[Math.floor(Math.random() * colorList.length)];

    return random_color;
}

export const getUserInitials = (userName, userSurname) => {
    const name = userName ? userName.toUpperCase() : '';
    const surname = userSurname ? userSurname.toUpperCase() : '';

    return `${name.charAt(0)}${surname.charAt(0)}`;
}

export const getFormatedDate = () => {
    const today= new Date();
    const year = today.getFullYear();
    const month = today.toLocaleString('en-UK', { month: 'long' })
    const day = today.getDate();

    return `${day} ${month} ${year}`;
}

export const convertObjNullToEmpty = (obj) => {
    if(obj === '' || obj === undefined ) return '';

    return Object.keys(obj).reduce((acc, key) => {
        acc[key] = obj[key] === null ? '' :
        obj[key]; return acc;
    }, {});
}
